import { useTranslation } from 'next-i18next'
import React from 'react'
import StepsSection from 'src/components/StepsSection'
import { RedirectUrls } from 'src/types/types'
import ga from 'src/utils/pixels/gtag'

const Steps = () => {
  const { t } = useTranslation('landing')
  return (
    <StepsSection
      title={t('INDEX_STEPS.HEADING')}
      subtitle={t('INDEX_STEPS.SUBHEADING')}
      steps={t('INDEX_STEPS.STEPS', { returnObjects: true })}
      // Three short steps fit one phone screen stacked; the carousel hid
      // steps two and three behind a swipe nobody made (1 click in 7 weeks).
      stackOnMobile
      ctaText={t('INDEX_STEPS.BUTTON_SEARCH')}
      ctaHref={RedirectUrls.Search}
      ctaClick={() =>
        ga.event('home_section_cta_click', {
          section: 'steps',
          cta: 'search',
          href: RedirectUrls.Search
        })
      }
    />
  )
}

export default React.memo(Steps)
